import { useTranslation } from "react-i18next";
import TooltipButton from "../primitives/TooltipButton";
import { cn } from "@/lib/utils";

export type PdfCardActions = {
  onSpeakerNotes: () => void;
  onShare: () => void;
  onMoveFolder: () => void;
  onDelete: () => void;
};

type PdfCardActionsProps = PdfCardActions & {
  disabled?: boolean;
};

export default function PdfCardActionsBar({
  onSpeakerNotes,
  onShare,
  onMoveFolder,
  onDelete,
  disabled,
}: PdfCardActionsProps) {
  const { t } = useTranslation();
  return (
    <div
      className={cn(
        "flex items-center gap-2",
        disabled && "pointer-events-none opacity-50"
      )}
    >
      <TooltipButton
        onClick={onSpeakerNotes}
        label={t("dashboard.speaker_notes")}
        icon="ri-sticky-note-line"
        bgClass="bg-amber-50 dark:bg-amber-500/15"
        textClass="text-amber-500 dark:text-amber-300"
        hoverBgClass="hover:bg-amber-100 dark:hover:bg-amber-500/25"
        hoverTextClass="hover:text-amber-600"
      />
      <TooltipButton
        onClick={onShare}
        label={t("dashboard.share")}
        icon="ri-share-line"
        bgClass="bg-teal-50 dark:bg-teal-500/15"
        textClass="text-teal-500 dark:text-teal-300"
        hoverBgClass="hover:bg-teal-100 dark:hover:bg-teal-500/25"
        hoverTextClass="hover:text-teal-600"
      />
      <TooltipButton
        onClick={onMoveFolder}
        label={t("dashboard.folder")}
        icon="ri-folder-transfer-line"
        bgClass="bg-indigo-50 dark:bg-indigo-500/15"
        textClass="text-indigo-500 dark:text-indigo-300"
        hoverBgClass="hover:bg-indigo-100 dark:hover:bg-indigo-500/25"
        hoverTextClass="hover:text-indigo-600"
      />
      <TooltipButton
        onClick={onDelete}
        label={t("common.delete")}
        icon="ri-delete-bin-line"
        bgClass="bg-red-50 dark:bg-red-500/15"
        textClass="text-red-400 dark:text-red-300"
        hoverBgClass="hover:bg-red-100 dark:hover:bg-red-500/25"
        hoverTextClass="hover:text-red-500"
      />
    </div>
  );
}
